// @flow

export const resetValue = 'unset';
